import { useClients } from '@entities/clients';
import {
  useGetClientByIdQuery,
  useSetClientColorTagMutation,
} from '@entities/clients/rtk-query.ts';
import cn from 'classnames';
import { useEffect, type FC } from 'react';
import { usePopup } from '@shared/hooks';
import type { ColorTag } from '@shared/types/common';
import { Blank } from '@src/library/components/common';
import * as st from './styles.module.scss';

type Props = {
  id: number;
  colorTags: ColorTag[];
  selectedColorTag: ColorTag;
  setSelectedColorTag: (colorTag: ColorTag | null) => void;
  resetSelectedColorTag: () => void;
};

export const ColorTagsList: FC<Props> = ({
  id,
  colorTags,
  selectedColorTag,
  setSelectedColorTag,
  resetSelectedColorTag,
}) => {
  const { popup } = usePopup();
  const { data: client } = useGetClientByIdQuery(Number(id));
  const [setClientColorTagMutation, { isLoading: isSetClientColorTagMutationLoading }] =
    useSetClientColorTagMutation();

  const { select } = useClients();

  useEffect(() => {
    resetSelectedColorTag();
    if (client?.color_tag) {
      setSelectedColorTag(colorTags.find((colorTag) => colorTag.color === client.color_tag)!);
    }
  }, [client]);

  const createFormData = (data: number) => {
    const clientData = new FormData();
    clientData.append('id', data.toString());
    return clientData;
  };

  const submit = async (data: number) => {
    const formData = createFormData(data);
    const resp = await setClientColorTagMutation({ id, body: formData });
    if (resp?.error) {
      popup({ type: 'error', text: `Произошла ошибка` });
    } else {
      select(id);
    }
  };

  return (
    <>
      {colorTags && colorTags.length === 0 && <Blank text="Здесь пока нет тегов" />}
      {colorTags && colorTags.length > 0 && (
        <section className={st.body}>
          <div className={st.colorTags}>
            {colorTags.map((colorTag: ColorTag) => {
              const isColorTagSelected =
                selectedColorTag?.color !== null
                  ? colorTag.color === selectedColorTag?.color
                  : colorTag.color === client?.color_tag;
              return (
                <div
                  className={st.colorTag}
                  key={colorTag.id}
                  onClick={(event) => {
                    event.preventDefault();
                    resetSelectedColorTag();
                    if (!isColorTagSelected) {
                      submit(colorTag.id);
                    }
                  }}
                >
                  <button
                    value={colorTag.color}
                    className={cn(st.color, isColorTagSelected && st.checked)}
                    style={{
                      backgroundColor: `${colorTag.color}`,

                      boxShadow: isColorTagSelected
                        ? `0px 0px 0px 2px #fff, 0 0 0 4px ${colorTag.color}`
                        : 'none',
                    }}
                  >
                    {/* <Mark /> */}
                  </button>
                  <div className={st.title}>{colorTag.title}</div>
                </div>
              );
            })}
          </div>
        </section>
      )}
    </>
  );
};
